import FilterBar from '@components/filter_bar/FilterBar.vue'
import pagination from './mixins/pagination'
import { tableConfig } from './utils/tableConfig'

export default {
  name: 'BasicTable',

  mixins: [pagination],

  components: {
    FilterBar,
  },

  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    config: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      reactiveKey: 0,
    }
  },

  computed: {
    tableConfig({ config = {} }) {
      return {
        ...tableConfig,
        ...config,
      }
    },
    isFullscreen() {
      return this.$store.getters['app/getIsFullscreen']
    },
  },

  created() {
    this.$nextTick(() => {
      this.$refs.xTableRef.connect(this.$refs.xToolbarRef)
    })
  },

  mounted() {
    this.refresh()
  },

  methods: {
    refresh(aParams = {}) {
      // const filterParams = this.getFilterParams();
      // const paginationParams = this.getPaginationParams();
      // const params = { ...filterParams, ...paginationParams, ...aParams };
      // console.log(params);
      const params = this.getParams(aParams)
      this.$emit('refresh', params)
    },

    handleTriggerFilter(filterParams = {}) {
      this.curPage = 1
      const paginationParams = this.getPaginationParams()

      this.refresh({
        ...filterParams,
        ...paginationParams,
      })
    },

    getParams(aParams = {}) {
      const filterParams = this.getFilterParams()
      const paginationParams = this.getPaginationParams()
      const params = { ...filterParams, ...paginationParams, ...aParams }
      return params
    },

    getFilterParams() {
      return this.$refs.filterBarRef.getFilterData()
    },

    setFilterValue(prop, value) {
      this.$refs.filterBarRef.setValue(prop, value)
    },

    getPaginationParams() {
      const { curPage, pageSize } = this
      return { pageNo: curPage, pageSize }
    },

    setPagination({ curPage, pageSize, total }) {
      if (curPage) {
        this.curPage = curPage
      }
      if (pageSize) {
        this.pageSize = pageSize
      }
      if (total !== undefined) {
        this.total = total
      }
    },

    setTotal(total) {
      this.setPagination({ total })
    },

    updateTable() {
      this.reactiveKey += 1
      this.$nextTick(() => {
        this.$refs.xTableRef.connect(this.$refs.xToolbarRef)
      })
    },
  },

  watch: {
    isFullscreen() {
      this.updateTable()
    },
  },
}
